module.exports = __webpack_public_path__ + "img/bg_首页.81b6784a.png";